import { render } from "./CustomSpinner.vue?vue&type=template&id=dc8da804&scoped=true&ts=true"
import script from "./CustomSpinner.vue?vue&type=script&lang=ts"
export * from "./CustomSpinner.vue?vue&type=script&lang=ts"

import "./CustomSpinner.vue?vue&type=style&index=0&id=dc8da804&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc8da804"]])

export default __exports__